export default new (class {
    constructor() {
        this._callbacks = [];
        window.onYouTubeIframeAPIReady = () => {
            this._onYoutubeReady();
        };

        window.addEventListener('DOMContentLoaded', () => {
            let newScript = document.createElement("script");
            newScript.src = "https://www.youtube.com/iframe_api";
            document.head.append(newScript);
        })
    }

    ready(cb) {
        this._callbacks.push(cb);
    }

    _onYoutubeReady() {
        this._callbacks.forEach(cb => cb());
    }
})();
